import React from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '../modules/auth'
import { useUserroles } from '../../Atom/contextProviders/Atomqueryprovider'


interface AdminRouteProps {
  children: React.ReactNode
}

const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
  const { currentUser } = useAuth()
  
  const {
    isLoading: userrolesloading,
    isSuccess: userrolessuccess,
    data: userrolesdata,
  } = useUserroles(Number(currentUser?.user_role_id))

  // Check if user is admin
  const isUserAdmin = () => {
    if (!userrolessuccess || !userrolesdata?.data) return false
    return userrolesdata.data.role_name === 'Admin' || userrolesdata.data.is_admin === true
  }

  // Show loading while checking user roles
  if (userrolesloading) {
    return <div>Loading...</div>
  }

  // If not admin, redirect to no rights page
  if (!isUserAdmin()) {
    return <Navigate to="/norights" replace />
  }

  // If admin, render the protected component
  return <>{children}</>
}

export { AdminRoute }